export const tablePaginationStyle = { position: 'sticky', left: '0px' };
